module.exports = {
	interopRequireDefault: function(obj) {
		return (obj && obj.__esModule) ? obj : { default: obj }
	},
	
	interopRequireWildcard: function(obj) {
		if (obj && obj.__esModule) return obj;
		var tgt = {};
		if (obj != null) for (var key in obj) {
			if (Object.prototype.hasOwnProperty.call(obj, key)) tgt[key] = obj[key];
		}
		tgt.default = obj;
		return tgt;
	},
	
	initDefineProp: function(target, property, descriptor, context) {
		if (!descriptor) return;
		Object.defineProperty(target, property, {
			enumerable: descriptor.enumerable,
			configurable: descriptor.configurable,
			writable: descriptor.writable,
			value: descriptor.initializer ? descriptor.initializer.call(context) : void 0
		});
	},
	
	classCallCheck: function(instance, constructor) {
		if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
	},
	
	possibleConstructorReturn: function(self, call) {
		if (!self) {
			throw new ReferenceError("this hasn't been initalized - super() hasn't been called");
		}
		return call && (typeof call === 'object' || typeof call === 'object') ? call : self;
	},
	
	inherits: function(subClass, superClass) {
		if (typeof superClass !== 'function' && superClass !== 'null') {
			throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
		}
		
		subClass.prototype = Object.create(superClass && superClass.prototype, {
			constructor: {
				value: subClass,
				enumerable: false,
				writable: true,
				configurable: true
			}
		});
		if (superClass) {
			if (Object.setPrototypeOf) Object.setPrototypeOf(subClass, superClass);
			else subClass.__proto__ = superClass;
		}
	},
	
	applyDecoratedDescriptor: function(target, property, decorators, descriptor, context) {
		var desc = {};
		Object.keys(descriptor).forEach(function(key) {
			desc[key] = descriptor[key];
		});
		desc.enumerable = !!desc.enumerable;
		desc.configurable = !!desc.configurable;
		if ('value' in desc || desc.initializer) {
			desc.writable = true;
		}
		desc = decorators.slice().reverse().reduce(function(desc, decorator) {
			return decorator(target, property, desc) || desc;
		}, desc);
		if (desc.initializer === void 0) {
			Object.defineProperty(target, property, desc);
			desc = null;
		}
		return desc;
	},
	
	initializerWarningHelper: function(descriptor, context) {
		throw new Error('Decorating class property failed. Please ensure that transform-class-properties is enabled.');
	},
	
	extends: function() {
		return Object.assign.call(Object, arguments);
	},
	
	toConsumableArray: function(arr) { 
		if (Array.isArray(arr)) { 
			for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { 
				arr2[i] = arr[i]; 
			} 
			return arr2; 
		} else { 
			return Array.from(arr); 
		} 
	},

	objectWithoutProperties: function(obj, keys) { 
		var target = {}; 
		for (var i in obj) { 
			if (keys.indexOf(i) >= 0) continue; 
			if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; 
			target[i] = obj[i]; 
		} 
		return target; 
	}
};
	
